import { KYBProgressStatusEnum, KYBProgressStatusHelpers } from 'anchor-kyb-service/types';
import { ff } from './ffSelectors';
import { filterAvailableRoutes } from './filterAvailableRoutes';
import { integrationSelectors } from './integrationSelectors';
import { userSelectors } from './userSelectors';
function impersonatingAs(state) {
    return state.claims ? state.claims.impersonate : null;
}
export const selectors = {
    ff,
    user: userSelectors,
    integration: integrationSelectors,
    filterAvailableRoutes,
    impersonatingAs,
    intercomUserHash (state) {
        return state.claims ? state.claims.intercomUserHash : null;
    },
    intercomUserJwt (state) {
        var _ref;
        var _state_userInfo;
        return (_ref = (_state_userInfo = state.userInfo) === null || _state_userInfo === void 0 ? void 0 : _state_userInfo.intercomUserJwt()) !== null && _ref !== void 0 ? _ref : null;
    },
    isResetPasswordFlow (param) {
        let { claims } = param;
        return claims ? claims.setPasswordOnly : false;
    },
    isSetIdentityFlow (param) {
        let { claims } = param;
        return claims ? claims.setIdentityOnly : false;
    },
    mgmtHost (state) {
        return state.session.mgmtHost;
    },
    pdfHost (state) {
        return state.session.pdfHost;
    },
    hasSentAProposal (state) {
        var _state_businessInfo;
        return ((_state_businessInfo = state.businessInfo) === null || _state_businessInfo === void 0 ? void 0 : _state_businessInfo.hasSentAProposal) || false;
    },
    hasSentASampleProposal (state) {
        var _state_businessInfo;
        return ((_state_businessInfo = state.businessInfo) === null || _state_businessInfo === void 0 ? void 0 : _state_businessInfo.hasSentASampleProposal) || false;
    },
    showMissingColumnBankAccountBanner (s) {
        var _s_personaKYBStatus_data;
        const userInfo = s.userInfo;
        return !!userInfo && userInfo.isVendor() && (userInfo.isOwner() || userInfo.isAdmin()) && !userInfo.paymentsDisabled() && userInfo.columnEntityCreated() && userInfo.hasColumnAccountId() && userInfo.hasColumnWalletAccountId() && !userInfo.hasColumnPayoutAccountId() && ((_s_personaKYBStatus_data = s.personaKYBStatus.data) === null || _s_personaKYBStatus_data === void 0 ? void 0 : _s_personaKYBStatus_data.status) === KYBProgressStatusEnum.Approved;
    },
    showUpdateKYBBanner (s) {
        const userInfo = s.userInfo;
        const { status } = s.personaKYBStatus.data || {};
        return !!status && !!userInfo && !KYBProgressStatusHelpers.isApproved(status) && !KYBProgressStatusHelpers.isAwaitingDecision(status) && userInfo.isVendor() && (userInfo.isOwner() || userInfo.isAdmin()) && !userInfo.paymentsDisabled();
    },
    shouldLoadAppcues (s) {
        return userSelectors.isVendor(s) && s.session.enableAppcues;
    },
    isRealUser (s) {
        return !!(s.userInfo && s.userInfo.id() && !impersonatingAs(s));
    },
    locationStack (s) {
        return s.locationStack;
    },
    teamInvites (s) {
        return s.teamInvites.data || [];
    },
    showBusinessSwitcher (s) {
        return !!s.userInfo && !userSelectors.isAccountant(s) && !userSelectors.isAnchorAdmin(s);
    }
};
